import { useQuery } from '@tanstack/react-query';
import { ApiResponse } from 'hooks/api/api';
import {
  AutomationsWorkflowsService,
  TCWorkflowVersion,
} from 'src/api/generated';

interface UseWorkflowVersionResponse extends ApiResponse {
  workflowVersion: TCWorkflowVersion | null;
}

export const useWorkflowVersion = (
  workflowId?: string,
  version?: string,
  enabled = true
): UseWorkflowVersionResponse => {
  const {
    data,
    error,
    isLoading: loading,
    refetch,
  } = useQuery<TCWorkflowVersion | null, Error>({
    queryKey: ['automations/workflows/version', { workflowId, version }],
    queryFn: async (): Promise<TCWorkflowVersion | null> => {
      if (!workflowId || !version) return null;
      return AutomationsWorkflowsService.getWorkflowVersion(
        workflowId,
        version
      );
    },
    enabled: enabled && !!workflowId && !!version,
  });

  return {
    loading,
    error: error || null,
    workflowVersion: data ?? null,
    refetch,
  };
};
